import CourseIndex from "@/module/education/nicheSideRoutes/Course/CourseIndex";
import DynamicStageDrawerIndexeIndex from "./DynamicStageDrawerIndex";
import Qualification from "@/module/education/nicheSideRoutes/Qualification/Qualification";
import ServiceIndex from "@/module/videoProduction/nicheSideRoutes/Service/ServiceIndex";
import ProgramIndex from "@/module/academy/nicheSideRoutes/Program/ProgramIndex";

export default function DynamicNichDrawer({ currentTab }: any) {
  const renderContent = () => {
    if (currentTab === "Course") {
      return <CourseIndex />;
    }
    if (currentTab === "Qualification") {
      return <Qualification />;
    }
    if (currentTab === "Service") {
      return <ServiceIndex />;
    }
    if (currentTab === "Program") {
      return <ProgramIndex />;
    }
    return <DynamicStageDrawerIndexeIndex />;
  };

  return renderContent();
}
